import { Text, Badge, Card, Heading, Inline, LinkButton, RadioCard, vars, textVariants, Stack } from '@etg/wings';
import { ScreenReaderPrice } from '@eti/components';
import { Check } from '@phosphor-icons/react';
import { AncillaryOption, TransferType } from '@eti/schema-types';
import { css } from '@eti/styles';
import { convertToHoursAndMinutes, AirportDirection } from './utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const cardWrapper = css`
  display: grid;
  grid-template-rows: auto 1fr auto;
`;
const priceStyles = css`
  display: flex;
  justify-content: end;
`;
const cardBodyWrapper = css`
  > *:not(:last-child) {
    margin-bottom: 16px;
  }
`;
const badgeStyles = css`
  border-radius: 8px;
  padding: 4px 8px;
`;
const CheckedItem = props => /*#__PURE__*/_jsxs(Inline, {
  alignY: "center",
  as: "li",
  "data-testid": props.testId,
  noWrap: true,
  spacing: 8,
  children: [/*#__PURE__*/_jsx(Check, {
    "aria-hidden": true,
    color: vars.colors.signal.positive.foreground,
    size: "1.25rem"
  }), props.children]
});
const OperatorCard = _ref => {
  let {
    operator,
    translation,
    handleOpenDrawer
  } = _ref;
  const {
    transferCarrier,
    ancillaryOption,
    transferTime,
    transferType,
    price,
    airportDirection,
    externalChoiceId
  } = operator;
  return /*#__PURE__*/_jsxs(RadioCard, {
    className: cardWrapper,
    "data-testid": "choice-container",
    id: `choiche-${externalChoiceId}`,
    label: /*#__PURE__*/_jsx(Heading, {
      as: "span",
      level: 3,
      children: transferCarrier
    }),
    value: String(externalChoiceId),
    children: [/*#__PURE__*/_jsxs(Card.Section, {
      className: cardBodyWrapper,
      children: [ancillaryOption && /*#__PURE__*/_jsx(Inline, {
        alignY: "center",
        as: "li",
        noWrap: true,
        spacing: 8,
        children: /*#__PURE__*/_jsx(Badge, {
          className: badgeStyles,
          "data-testid": "ancillary-option",
          children: ancillaryOption === AncillaryOption.Cheapest ? translation.card.cheapest : translation.card.fastest
        })
      }), /*#__PURE__*/_jsxs(Stack, {
        spacing: 8,
        children: [/*#__PURE__*/_jsx(CheckedItem, {
          testId: "transfer-type",
          children: `${transferType === TransferType.Bus ? translation.card.bus : translation.card.train} ${translation.card.transfer}`
        }), /*#__PURE__*/_jsx(CheckedItem, {
          testId: "transfer-time",
          children: convertToHoursAndMinutes(transferTime !== null && transferTime !== void 0 ? transferTime : 0, translation.card.hour, translation.card.hours, translation.card.minute, translation.card.minutes, translation.card.transferTime)
        }), (airportDirection === AirportDirection.Both || airportDirection === AirportDirection.From) && /*#__PURE__*/_jsx(CheckedItem, {
          children: `${translation.card.transportAvailable} ${translation.card.fromAirport} `
        }), (airportDirection === AirportDirection.Both || airportDirection === AirportDirection.To) && /*#__PURE__*/_jsx(CheckedItem, {
          children: `${translation.card.transportAvailable} ${translation.card.toAirport} `
        })]
      }), /*#__PURE__*/_jsx(LinkButton, {
        onClick: () => {
          handleOpenDrawer(operator);
        },
        children: translation.card.seeDetails
      })]
    }), /*#__PURE__*/_jsx(Card.Section, {
      children: /*#__PURE__*/_jsxs(Inline, {
        alignY: "center",
        className: priceStyles,
        noWrap: true,
        spacing: 8,
        children: [/*#__PURE__*/_jsx(Text, {
          children: translation.card.perPerson
        }), /*#__PURE__*/_jsx(Text, {
          "aria-hidden": true,
          "data-testid": "operator-price",
          variant: textVariants._18_EMPHASIZED,
          children: price
        }), /*#__PURE__*/_jsx(ScreenReaderPrice, {
          price: price
        })]
      })
    })]
  });
};
export default OperatorCard;
//# sourceMappingURL=OperatorCard.js.map